module.exports = __webpack_public_path__ + "static/media/yajiankang_geren_icon.87fa97ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yajiankang_geren_icon.png
// module id = 410
// module chunks = 0